module.exports = __webpack_public_path__ + "static/media/2.6fc66cf9.jpg";